import React, { FormEvent, KeyboardEvent } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, InputGroup, OverlayTrigger, Table, Well } from 'react-bootstrap';
import { CompatiblePairRatioOverlay } from '@nkr/views/center-admin/action-center/center-performance/relative-performance-overlays';
import { ICprScoreAudit } from '@nkr/models/reports';

interface IProps {
    data: ICprScoreAudit[],
    reportStart: string,
    reportEnd: string,
    included: boolean,
    compatible: boolean,
    transplanted: boolean,
    txpIncluded: number,
    txpCompatible: number,
    cprScore: number,
    onReportStartChange: (reportStart: string) => void,
    onReportEndChange: (reportEnd: string) => void,
    onReportRangeUpdate: () => void,
    onFilterToggle: (name: string, value: boolean) => void,
    onCompatibleTotalOnly: () => void,
    onIncludedTotalOnly: () => void
}

const Header = ({ data, reportStart, reportEnd, included, compatible, transplanted, txpIncluded, txpCompatible, cprScore, onReportStartChange, onReportEndChange, onReportRangeUpdate, onFilterToggle, onCompatibleTotalOnly, onIncludedTotalOnly }: IProps) => {
    const handleDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'reportStart') {
            onReportStartChange(value);
        }

        if (name == 'reportEnd') {
            onReportEndChange(value);
        }
    };

    const handleDateKeyUp = (e: KeyboardEvent<FormControl & HTMLInputElement>) => {
        if (e.key == 'Enter') {
            onReportRangeUpdate();
        }
    };

    const handleFilterToggle = (e: FormEvent<HTMLButtonElement>) => {
        if (e.currentTarget.name == 'included') {
            onFilterToggle(e.currentTarget.name, !included);
        }

        if (e.currentTarget.name == 'compatible') {
            onFilterToggle(e.currentTarget.name, !compatible);
        }
    };

    const handleTransplantedToggle = (e: FormEvent<HTMLButtonElement>) => {
        let transplanted: boolean = null;

        if (e.currentTarget.value == '1') {
            transplanted = true;
        }

        if (e.currentTarget.value == '0') {
            transplanted = false;
        }

        onFilterToggle('transplanted', transplanted);
    };

    return (
        <Well bsSize='sm' style={{ marginBottom: 5 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <div className='form-inline'>
                        <FormGroup style={{ marginRight: 50 }}>
                            <ControlLabel>Report Range:&nbsp;</ControlLabel>
                            <InputGroup>
                                <FormControl name='reportStart' type='date' onChange={handleDateChange} onKeyUp={handleDateKeyUp} value={reportStart} />
                                <InputGroup.Addon>&nbsp;-&nbsp;</InputGroup.Addon>
                                <FormControl name='reportEnd' type='date' onChange={handleDateChange} value={reportEnd} />
                                <InputGroup.Button>
                                    <Button bsStyle='primary' onClick={onReportRangeUpdate}>Update</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup style={{ marginRight: 50 }}>
                            <ControlLabel>Filter:&nbsp;</ControlLabel>
                            <div className='btn-group' role='group' aria-label='filters'>
                                <button type='button' name='compatible' className={compatible ? 'btn btn-primary' : 'btn btn-default'} onClick={handleFilterToggle}>Compatible</button>
                                <button type='button' name='included' className={included ? 'btn btn-primary' : 'btn btn-default'} onClick={handleFilterToggle}>Included</button>
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Transplanted:&nbsp;</ControlLabel>
                            <button type='button' name='transplanted' className={transplanted == true ? 'btn btn-primary' : 'btn btn-default'} value='1' onClick={handleTransplantedToggle}>Yes</button>
                            <button type='button' name='tranplanted' className={transplanted == false ? 'btn btn-primary' : 'btn btn-default'} value='0' onClick={handleTransplantedToggle}>No</button>
                            <button type='button' name='tranplanted' className={transplanted == null ? 'btn btn-primary' : 'btn btn-default'} value='-1' onClick={handleTransplantedToggle}>Either</button>
                        </FormGroup>
                    </div>
                </div>
                <div>
                    <Table bordered style={{ width: 'initial', backgroundColor: 'white', marginBottom: 0 }}>
                        <tbody>
                            <tr>
                                <td># Compatible: <a style={{ cursor: 'pointer', fontWeight: 700 }} onClick={onCompatibleTotalOnly}>{txpCompatible}</a></td>
                                <td># Included: <a style={{ cursor: 'pointer', fontWeight: 700 }} onClick={onIncludedTotalOnly}>{txpIncluded}</a></td>
                                <td>
                                    {
                                        <OverlayTrigger trigger={['hover', 'hover']} placement='left' overlay={<CompatiblePairRatioOverlay />}>
                                            <div style={{ cursor: 'pointer' }}>
                                                CPR Result: <strong>{cprScore.toString()}</strong>
                                            </div>
                                        </OverlayTrigger>
                                    }
                                </td>
                                <td>Transplants in Report Range: <strong>{data.length}</strong></td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        </Well>
    );
}

export default Header;